import { useIsThisPage } from '@/hooks/useIsThisPage';
import { AppRoutes } from '@/i18n/constants';
import { useRouter } from '@/i18n/routing';

type Params = {
  page: string;
  match?: 'segment' | 'exact';
  onCloseAction: () => void;
};

export const useCloseAuthModal = ({ page, match, onCloseAction }: Params) => {
  const isCorrectPage = useIsThisPage(page, match);
  const router = useRouter();

  const handleCloseModal = () => {
    if (isCorrectPage) {
      router.push(AppRoutes.home);
    } else {
      onCloseAction();
    }
  };

  return {
    handleCloseModal,
  };
};
